export const IMPORT_GROUP_PENDING = 1;
export const IMPORT_GROUP_IMPORTING = 2;
export const IMPORT_GROUP_IMPORTED = 3;
export const IMPORT_GROUP_MANUALLY_IMPORTED = 4;
export const IMPORT_GROUP_ERROR = 5;
